import { selectors } from 'app/services/projects';
import { useSelector } from 'react-redux';
import { Datagrid } from 'components';

const CommentsTab = () => {
  const project = useSelector(selectors.getProject);

  return <Datagrid
    data={project}
    groupedKeys={[
      { keys: [ 'QuantitiesComments', 'CloseNotes', 'OtherComments', 'SafetyComments' ] },
    ]}
    translationsNamespace='entities.project'
  />;
};

export default CommentsTab;